export default __webpack_public_path__ + "static/media/calcBG.c6757cbe.jpg";